import { Stack, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { FinancialBalanceRowLabel } from "web_myplann/Dashboard/Components/FinancialBalanceRowLabel";
import { AmountWithCurrency } from "web_myplann/Shared/Components/AmountWithCurrency";
import { numberFormatter } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	icon: LucideIcon;
	iconColor: string;
	label: string;
	amount: number;
};

export const FinancialBalanceRow: FC<Props> = ({
	icon,
	iconColor,
	label,
	amount,
}) => {
	const theme = useTheme();

	return (
		<Stack direction="row" alignItems="center" justifyContent="space-between">
			<FinancialBalanceRowLabel
				icon={icon}
				iconColor={iconColor}
				label={label}
			/>
			<AmountWithCurrency
				amount={numberFormatter.format(amount)}
				variant="bodyStrong"
				suffixVariant="caption"
				suffixColor={theme.palette.grey[500]}
			/>
		</Stack>
	);
};
